const PART_BYTES = 16 * 1024 * 1024;

export type RetainedPart = {
  partNumber: number;
  etag: string;
  checksumSha256?: string | null;
  sizeBytes?: number | null;
};

export type PendingPart = {
  partNumber: number;
  body: Blob;
  checksumSha256: string;
};

const base64 = (bytes: ArrayBuffer) => {
  let binary = '';
  for (const value of new Uint8Array(bytes)) binary += String.fromCharCode(value);
  return btoa(binary);
};

async function checksum(part: Blob, locale?: string) {
  if (!globalThis.crypto?.subtle) throw new Error(workspaceErrorCopy(locale).browserChecksum);
  return base64(await crypto.subtle.digest('SHA-256', await part.arrayBuffer()));
}

export async function reconcileMultipartParts(
  file: Blob,
  serverParts: RetainedPart[] = [],
  locale?: string,
) {
  const serverByNumber = new Map(serverParts.map((part) => [part.partNumber, part]));
  const retained = new Map<number, RetainedPart>();
  const pending: PendingPart[] = [];
  for (let offset = 0, partNumber = 1; offset < file.size; offset += PART_BYTES, partNumber += 1) {
    const body = file.slice(offset, Math.min(file.size, offset + PART_BYTES));
    const checksumSha256 = await checksum(body, locale);
    const existing = serverByNumber.get(partNumber);
    if (existing?.checksumSha256 === checksumSha256 && Number(existing.sizeBytes) === body.size)
      retained.set(partNumber, existing);
    else pending.push({ partNumber, body, checksumSha256 });
  }
  return { pending, retained, partBytes: PART_BYTES };
}
import { workspaceErrorCopy } from './workspace-errors';
